import React, { useEffect, useState } from 'react'
import AdminBreadcrumb from '../Common/AdminBreadcrumb';
import { Link, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { GetDynamicText, DeleteDynamicText, DetailDynamicText } from '../../../API/admin'
import Swal from 'sweetalert2'
import {
    CButton,
    CCard,
    CCardBody,
    CCol,
    CRow,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter
} from '@coreui/react'

const DynamicText = () => {
    // Manage AdminBreadcrumb
    const adminBreadcrumbLinks = [
        { label: 'Dashboard', to: '/admin/dashboard', active: false },
        { label: 'DynamicText', to: '/dynamic_text', active: true }
    ];

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const Navigate = useNavigate();
    const [DynamicTextDetail, setDynamicTextDetail] = useState({
        name: '',
        value: "",
        description: ""
    });
    const [allDynamicText, setallDynamicText] = useState([]);
    const [selectedOption, setSelectedOption] = useState('email')
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        getUserAPI()
    }, [])

    let getUserAPI = async (type = 'email') => {
        let res = await GetDynamicText(type)
        console.log(res.data)
        if (res.status) {
            setallDynamicText(res.data);
        } else {
            setallDynamicText([]);
        }
    }

    // const HandelChange = (event) => {
    //     // event.preventDefault;
    //     // console.log(event.target.value);
    //     let search = event.target.value;
    //     // console.log("yes");
    //     // let usersarr = Users;
    //     const subArr = alluser.filter(user => (user.fname.includes(search) || (user.corporate_email!=null && user.corporate_email.includes(search)) || user.email.includes(search)) );
    // //   console.log("sub",subArr);
    //   setUsers(subArr);
    //     // callAPI(search);

    // }

    const HandelDelete = async (urlid) => {
        let res = await Swal.fire({
            title: "Are you sure?",
            text: "Are you sure , you want to delete this DynamicText?",
            // icon: "warning"
        });
        if (res.isConfirmed) {
            let callAPI = async () => {
                let userID = {
                    id: urlid
                }
                console.log(userID);

                let res = await DeleteDynamicText(userID);
                if (res.status) {
                    enqueueSnackbar("DynamicText Deleted successfully", {
                        variant: 'success', action: (key) => (
                            <button className='toast_close_btn'
                                onClick={() => {
                                    // Close the Snackbar
                                    closeSnackbar(key);
                                }}
                            >
                                X
                            </button>
                        ),
                    });
                    getUserAPI()
                } else {
                    enqueueSnackbar("Can not delete DynamicText", {
                        variant: 'error', action: (key) => (
                            <button className='toast_close_btn'
                                onClick={() => {
                                    // Close the Snackbar
                                    closeSnackbar(key);
                                }}
                            >
                                X
                            </button>
                        ),
                    });
                    Navigate('/DynamicText')
                }
            }
            callAPI();
        }
    }

    const detailDynamicText = async (id) => {
        let res = await DetailDynamicText(id);
        setDynamicTextDetail({
            name: res.data.name,
            value: res.data.value,
            description: res.data.description
        })
        setVisible(true)
        console.log(res)
    }

    function truncateText(text, maxWords) {
        const words = text.split(' ');
        if (words.length > maxWords) {
            return words.slice(0, maxWords).join(' ') + '...';
        }
        return text;
    }

    const handleSelectChange = (e) => {
        setSelectedOption(e.target.value);
        getUserAPI(e.target.value);
    };

    function stripHtml(html) {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    }


    return (
        <>
            <AdminBreadcrumb links={adminBreadcrumbLinks} />
            <CCard className="mb-4">
                <CCardBody>
                    <CRow>
                        <CCol sm={4}>
                            <h3 className="card-title mb-3">
                                DynamicText
                            </h3>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm={6}>
                            <select className='form-select' value={selectedOption} onChange={handleSelectChange}>
                                <option value="email">Email</option>
                                <option value="text">Text</option>
                            </select>
                        </CCol>
                        {/* Select box */}

                        <CCol sm={6} className="d-none d-md-block" >
                            {/* {
                        selectedOption == 'email' ? (
                            <Link to= {`/dynamic_text/create?type=email`}>     
                                <CButton className='float-end text-white' color="info" >
                                <i className="bi bi-plus-circle me-2"></i>
                                    Add Dynamic {selectedOption}</CButton>
                            </Link>

                        ) : (<Link to= {`/dynamic_text/create?type=text`}>     
                            <CButton className='float-end text-white' color="info" >
                            <i className="bi bi-plus-circle me-2"></i>
                                Add Dynamic {selectedOption}</CButton>
                        </Link>)
                    } */}
                        </CCol>
                    </CRow><br />
                    {/* <MainChart /> */}
                    <CRow
                        xs={{ cols: 1, gutter: 4 }}
                        sm={{ cols: 2 }}
                        lg={{ cols: 4 }}
                        xl={{ cols: 5 }}
                        className="mb-2 text-center cstm_scrl_withdrawel"
                    >
                        <CTable striped className=''>
                            <CTableHead>
                                <CTableRow>
                                    <CTableHeaderCell scope="col">S.NO</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Name</CTableHeaderCell>
                                    <CTableHeaderCell scope="col"> {selectedOption == 'email' ? 'Subject' : 'Title'}</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">{selectedOption == 'email' ? 'Body' : 'Value'}</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Description</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Action</CTableHeaderCell>

                                </CTableRow>
                            </CTableHead>
                            <CTableBody>
                                {allDynamicText.length === 0 ? (
                                    <tr>
                                        <td colSpan="6">No data found</td>
                                    </tr>
                                ) : (
                                    allDynamicText.map((entry, index) => (
                                        <CTableRow>
                                            <CTableHeaderCell key={index}>{index + 1}</CTableHeaderCell>
                                            <CTableDataCell key={index}>{entry.name}</CTableDataCell>
                                            <CTableDataCell key={index}>
                                                <div style={{ width: "180px" }}> {entry.title != undefined ? entry.title : 'N/A'}</div>
                                            </CTableDataCell>
                                            <CTableDataCell key={index}>
                                                <div style={{ width: "200px" }}> {entry.value !== undefined ? truncateText(stripHtml(entry.value), 8) : 'N/A'}</div>
                                            </CTableDataCell>

                                            <CTableDataCell key={index}>{truncateText(entry.description, 8)} </CTableDataCell>

                                            <CTableDataCell key={index}>
                                                <div className='d-flex justify-content-center'>
                                                    <CButton className='bi bi-eye-fill text-white admin_btn_space' onClick={(e) => detailDynamicText(entry.id)} color="primary"></CButton>
                                                    <Link to={`/dynamic_text/edit?id=${entry.id}&type=${selectedOption}`}>
                                                        <CButton className="bi bi-pencil text-white admin_btn_space" color="warning"></CButton>
                                                    </Link>

                                                </div>
                                            </CTableDataCell>

                                        </CTableRow>
                                    ))
                                )}
                            </CTableBody>
                        </CTable>
                    </CRow>
                </CCardBody>
            </CCard>

            <CModal
                visible={visible}
                onClose={() => setVisible(false)}
                aria-labelledby="ScrollingLongContentExampleLabel"
            >
                <CModalHeader>
                    <CModalTitle id="ScrollingLongContentExampleLabel">DynamicText</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <h5>Name: </h5>
                    <p className='mb-3'>
                        {DynamicTextDetail.name}
                    </p>
                    <h5> Value :</h5>
                    <p>
                        {DynamicTextDetail.value}

                    </p>
                    <h5> Description :</h5>
                    <p>
                        {DynamicTextDetail.description}

                    </p>
                </CModalBody>
                <CModalFooter>
                    <CButton color="secondary" onClick={() => setVisible(false)}>
                        Close
                    </CButton>
                </CModalFooter>
            </CModal>
        </>
    )
}
export default DynamicText;